import React from 'react';

import LinksPageLayout
  from 'components/dashboard/links-content/links-layout/LinksPageLayout';
import MusicLinksPageContent from 'components/dashboard/music-links-content/MusicLinksPageContent';

const DashboardMusicLinksPage = () => (
  <LinksPageLayout activeLinksPage="music">
    <MusicLinksPageContent />
  </LinksPageLayout>
);

export default DashboardMusicLinksPage;
